import React from "react";
import ReactModal from "react-modal";
import { axiospost, axiosput } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import { Field, Form, Formik } from "formik";
import { ms_applicant_sitting } from "@v2/validators";
import ErrorMessage from "../../components/ErrorMessage";
import { useQueryClient } from "@tanstack/react-query";

const BtnOLevel = ({ modules }) => {
  const [showmodal, setshowmodal] = React.useState(false);
  const queryClient = useQueryClient();

  const _save = async (values) => {
    try {
      let req;
      if (modules === undefined) {
        req = await axiospost("ms_applicant_sitting", values);
      } else {
        req = await axiosput(`ms_applicant_sitting/${modules?._id}`, values);
      }
      if (req.status !== 200) {
        throw new Error("Sorry, system could not finish processing your request");
      }
      const { data: result } = req;
      if (result && result.type === "success") {
        const { message, type } = result;
        swal(type, message);
        queryClient.invalidateQueries({ queryKey: ["oLevelSitting"] });
      } else {
        throw new Error(result.message);
      }
    } catch ({ message }) {
      swal("warning", message);
    }
  };

  const _show = () => {
    setshowmodal(true);
  };

  return (
    <div>
      <ReactModal isOpen={showmodal} onRequestClose={() => setshowmodal(false)} className="ReactModal">
        <div className="modal-dialog " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-center">Student O-Level Sitting</h5>
              <span className="pointer text-danger" onClick={() => setshowmodal(false)}>
                x
              </span>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={{
                  examinationtype: modules ? modules?.examinationtype : "",
                  examinationcenter: modules ? modules?.examinationcenter : "",
                  examinationyear: modules ? modules?.examinationyear : "",
                  examinationnumber: modules ? modules?.examinationnumber : "",
                }}
                validationSchema={ms_applicant_sitting.createSitting}
                initialTouched={{ zip: true }}
                onSubmit={_save}
              >
                {({ isSubmitting, touched, errors }) => (
                  <Form>
                    <div className="row">
                      <div className="col-md-6 ">
                        <div className="form-group form-floating">
                          <Field
                            as="select"
                            name="examinationtype"
                            id=""
                            errors={errors?.examinationtype}
                            className={`form-control form-control-lg ${errors?.examinationtype && "is-invalid"}`}
                          >
                            <option value="">Select Option</option>
                            <option value="WAEC"> WAEC</option>
                            <option value="NECO"> NECO</option>
                            <option value="NABTEB"> NABTEB</option>
                            <option value="NBAIS"> NBAIS</option>
                            <option value="GCE"> GCE</option>
                            <option value="GRADE II"> GRADE II</option>
                          </Field>
                          <label htmlFor="firstname">Select Examination Type</label>
                          {errors?.examinationtype && touched?.examinationtype ? (
                            <div className="text-danger mt-1 p-1 text-small">{errors?.examinationtype}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <ErrorMessage
                          name={"examinationcenter"}
                          label="Examination Centre Number"
                          key={`error_examinationcenter`}
                          errors={errors?.examinationcenter}
                          touched={touched?.examinationcenter}
                        />
                      </div>
                      <div className="col-md-6">
                        <ErrorMessage
                          name={"examinationyear"}
                          label="Examination Year"
                          key={`error_examinationyear`}
                          errors={errors?.examinationyear}
                          touched={touched?.examinationyear}
                        />
                      </div>
                      <div className="col-md-6">
                        <ErrorMessage
                          name={"examinationnumber"}
                          label="Examination Number"
                          key={`error_examinationnumber`}
                          errors={errors?.examinationnumber}
                          touched={touched?.examinationnumber}
                        />
                      </div>
                      <div className="col-md-12 text-right">
                        <button disabled={isSubmitting} type="submit" className="btn btn-lg btn-block btn-primary ml-1">
                          {isSubmitting ? `Please wait...` : `Save`}
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </ReactModal>
      <div>
        {!modules && (
          <div
            style={{
              position: "fixed",
              right: "50px",
              bottom: "50px",
            }}
          >
            <button className="btn btn-icon btn-primary btn-rounded" onClick={_show}>
              <i className="ti-plus"></i>
            </button>
          </div>
        )}
      </div>
      <div>
        {modules && (
          <button className="btn btn-icon btn-primary btn-rounded" onClick={_show}>
            <i className="ti-pencil"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default BtnOLevel;
